/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { createAdditionalInfos } from "../../../../apis/companies/company-infos";
import Form from "../../../../components/Form";
import Modal, { ModalHeader } from "../../../../components/Modal";
import useForm from "../../../../hooks/useForm";
import { viewLoading } from "../../../../utils/loading";

const Additional = ({ mode = "create", type, open, setOpen, submit }) => {
  const [formFields, setFormFields] = useState([]);

  useEffect(() => {
    setFormFields([
      [{ title: "제목", key: "title", type: "input", required: true }],
      [
        {
          title: "첨부파일",
          key: "fileIdx",
          type: "dropzone",
          isSingle: true,
          accept: "image/*", // type === 2 ? "image/*" : "",
          required: true,
        },
      ],
    ]);
  }, []);


  const getTableTitle = (type) => {
    let title = "";

    switch (type) {
      case 1:
        title = "통장사본";
        break;
      case 2:
        title = "인감";
        break;
      case 3:
        title = "사업자등록증";
        break;
      default:
        break;
    }
    return title;
  };

  const validate = ({ title, fileIdx }) => {
    let errors = {};

    if (!title) errors.title = "제목은 필수입니다.";
    if (!fileIdx) errors.fileIdx = "첨부파일은 필수입니다.";

    return errors;
  };

  const _submit = (form) => {
    viewLoading(true);
    createAdditionalInfos({ type, ...form })
      .then((res) => {
        setOpen({ type, open: false });
        submit();
        reset();
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        viewLoading(false);
      });
  };

  const {
    form,
    // setForm,
    errors,
    handleOnChange,
    handleSubmit,
    reset,
  } = useForm(
    {
      title: "",
      fileIdx: "",
    },
    _submit,
    validate,
  );

  const cancel = (e) => {
    e.preventDefault();
    setOpen({ type, open: false });
    if (mode === "create") reset();
  };

  return (
    <Modal isOpen={type === open.type && open.open} close={cancel}>
      <div className="additional-write">
        <ModalHeader>
          {getTableTitle(type)} {mode === "create" ? "추가" : "수정"}
        </ModalHeader>
        <Form
          fields={formFields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default Additional;
